import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import logo from '../Images/logo.jpg' 
import MenuItem from './MenuItem.js'
import '../Styles/Menu.css';

const initialPathIndex = (url) => {

	if (url === "/") {
		return 0
	} else if (url === "/info") {
		return 1
	} else if (url === '/terms_and_conditions'){
		return 2
	} else if (url === '/courier') {
		return 3
	}
}

class Menu extends Component{

	state = {
		activeIndex: 0
	}


	handleClick = index => {
		this.setState({activeIndex: index})
	}

	componentDidMount()  {
		
		const initialIndex = initialPathIndex(window.location.pathname)
		this.setState({activeIndex: initialIndex})
	}
	
	render() {
		return (
			<div id="Menu"> 
				<nav>
					<ul className="nav-menu-list">
						<Link 
							to="/"
							onClick={() => this.handleClick(0)}
						>
							<MenuItem 
								text="Home" 
								isActive={this.state.activeIndex===0}
							/>
						</Link>
						
						<Link 
							to="/info"
							onClick={() => this.handleClick(1)}
						>
							<MenuItem 
								text="How it works"
								isActive={this.state.activeIndex===1}
							/>
						</Link>
						<Link
							to="/courier"
							onClick={() => this.handleClick(3)}
						>
							<MenuItem
								text="Courier options"
								isActive={this.state.activeIndex===3}
							/>
						</Link>
						{/*<Link 
							to="/terms_and_conditions"
							onClick={() => this.handleClick(2)}
						>
							<MenuItem 
								text="Ts & Cs"
								isActive={this.state.activeIndex===2}
							/>
						</Link>*/}

					</ul>
					<div className="icon-container">
						<img className="logo-img" src={logo} alt=""/>
					</div>

					{/*<div className="icon-container">
						 <Link to="/sign_in"> 
						 	sign-in / register  
						 	<i className="user circle outline icon"> 
						 	</i> </Link> 
						 </div>*/}
				</nav>
			</div>
		)
	}
}

export default Menu;